/**
 * @typedef {import('./NavigationListComponent').Props} Props
 * @typedef {import('./NavigationListComponent').State} State
 * @typedef {Omit<Props, 'location' | 'settings'>} PublicProps
 */
import { matchPath, withRouter } from 'react-router-dom';
import { withSettings } from '../../shared/SettingProvider/SettingProvider';
import NavigationListLink from './NavigationListLink';
import React from 'react';

/**
 * @param {Props} props
 * @returns {boolean}
 */
function hasActiveLink(props) {
	return props.links.some((link) => {
		if (link.to.includes('://') || props.location === undefined) {
			return false;
		}

		return matchPath(props.location.pathname, {
			path: link.to,
		});
	});
}

/** @extends {React.Component<Props, State>} */
class NavigationList extends React.Component {
	static defaultProps = {
		appendItem: null,
		collapsible: false,
		color: 'info-contrasted',
	};

	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		this.state = {
			isCollapsed: false,
		};

		this.handleToggle = this.handleToggle.bind(this);
	}

	/**
	 * @param {Props} prevProps
	 * @returns {void}
	 */
	componentDidUpdate(prevProps) {
		if (
			prevProps.location?.pathname !== this.props.location?.pathname &&
			hasActiveLink(this.props) &&
			this.state.isCollapsed
		) {
			this.setState({ isCollapsed: false });
		}
	}

	/**
	 * @returns {void}
	 */
	handleToggle() {
		this.setState((state) => ({ isCollapsed: !state.isCollapsed }));
	}

	/**  @returns {JSX.Element} */
	render() {
		const linkList = this.props.links
			.filter((link) => {
				if (link.flag === undefined || link.userTier === undefined) {
					return true;
				}

				return this.props.settings.isEnabled(link.flag, link.userTier);
			})
			.map(
				/**
				 *
				 * @param {Props['links'][0]} link
				 * @returns {JSX.Element}
				 */
				(link) => (
					<NavigationListLink
						disable={link.disable}
						exact={link.exact}
						icon={link.icon}
						isSubmenu={link.isSubmenu}
						key={link.key}
						linkClickHandler={link.linkClickHandler}
						onListItemClick={this.props.onListItemClick}
						to={link.to}
					>
						{link.label}
					</NavigationListLink>
				)
			);

		return (
			<React.Fragment>
				<h2
					className={`nav-heading ${
						this.props.collapsible ? 'nav-heading-collapsible' : ''
					}`.trim()}
				>
					{this.props.collapsible ? (
						<button
							aria-expanded={!this.state.isCollapsed}
							className="nav-heading-button"
							onClick={this.handleToggle}
							type="button"
						>
							<span className="nav-heading-title">
								{this.props.heading}
							</span>
							<span
								aria-hidden="true"
								className="nav-heading-indicator"
							>
								{this.state.isCollapsed ? '+' : '-'}
							</span>
						</button>
					) : (
						this.props.heading
					)}
				</h2>
				<ul className="nav-group" hidden={this.state.isCollapsed}>
					{linkList}
					{this.props.appendItem}
				</ul>
			</React.Fragment>
		);
	}
}
export default /** @type {React.ComponentType<PublicProps>} */ (
	/** @type {(component: React.ComponentType<Omit<Props, 'settings'>>) => React.ComponentType<PublicProps>} */ (
		/** @type {unknown} */ (withRouter)
	)(
		/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Omit<Props, 'settings'>>} */ (
			/** @type {unknown} */ (withSettings)
		)(NavigationList)
	)
);
